import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';

import { ArrayExpansionBoxComponent } from './array-expansion-box.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [ArrayExpansionBoxComponent],
  declarations: [ArrayExpansionBoxComponent]
})
export class ArrayExpansionBoxModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/array-expansion-box/array-expansion-box.module.ts